// extracted by mini-css-extract-plugin
export default {"body":"Register_body__5yMR2"};